import React from 'react';
import {FontStyles, Routes} from "../../components/constants";
import uuid from 'uuid/v4'
import {dbStories} from "components/firebase";
import {Flex} from "components/common_style/flex";
import titlebg from '../../assets/backgrounds/title.jpg';
import {Span} from "components/common_style/text";
import {TextField} from "@material-ui/core";
import {TextInput} from "components/common_style/text_input";
import {Colors} from "components/constants";
import {Button, ButtonOutline} from "components/common_style/button";
import * as firebase from "firebase";
import {Localization} from "localizations/languages";

class StoryEditorTitle extends React.Component {
    constructor(props) {
        super(props);
        if (window.location.hash.length === 0) props.history.replace(Routes.myStories);
        this.state = {
            uuidKey: uuid(),
            loading: true,
            title: '',
            name: '',
        };
        this.storyId = this._parseHashStoryId(window.location.hash);
        this.pageN = this._parseHashPage(window.location.hash);
        if (this.storyId.length === 0) {
            this.props.history.replace(Routes.myStories);
            return;
        }
        this.story = dbStories.doc(this.storyId);
        this._loadData();

    }

    _parseHashStoryId(hash) {
        hash = hash.substring(1);
        if (hash.includes('&')) {
            return hash.split('&')[0]
        } else {
            return hash;
        }
    }

    _parseHashPage(hash) {
        if (hash.includes('&')) {
            return parseInt(hash.split('&')[1]);
        } else {
            return 0;
        }
    }

    async _loadData() {
        try {
            this.storyData = (await this.story.get()).data();
        } catch (e) {
            // error.code === 'permission-denied'
            this.props.history.replace(Routes.myStories);
            return;
        }

        this.setState({
            title: this.storyData.title,
            name: this.storyData.author
        })
    }

    render() {
        return <Flex column vAlign={'center'} hAlign={'center'}
                     style={{backgroundImage: 'url("' + titlebg + '")', width: '100%', height: '100%'}}>
            <Flex column style={{padding: '140px 100px 140px 100px', backgroundColor: 'white'}}>
                <TextInput onChange={(e) => this.onTitleChange(e)} inputStyle={FontStyles.largeInput}
                           labelStyle={FontStyles.darkLabel} width={'390px'} bgColor={Colors.primaryOpaqueLight}
                           id={"title"} label={Localization.current.translation43} name={'title'}
                           style={{marginBottom: 40, ...FontStyles.darkLabel}} value={this.state.title}/>
                <TextInput onChange={(e) => this.onAuthorChange(e)} inputStyle={FontStyles.largeInput}
                           labelStyle={FontStyles.darkLabel} width={'390px'} bgColor={Colors.primaryOpaqueLight}
                           id={"name"} label={Localization.current.translation44} name={'name'} style={{marginBottom: 60}}
                           value={this.state.name}/>
                <Flex wmax hAlign={'space-between'}>
                    <ButtonOutline onClick={() => this.cancelAndQuit()} style={{width: 190, height: 40}}>{Localization.current.translation45}</ButtonOutline>
                    <Button onClick={() => this.saveAndContinue()} style={{width: 190, height: 40}}>{Localization.current.translation46}</Button>
                </Flex>
            </Flex>
            <Flex hAlign={'center'} style={{position: 'absolute', top: 70, left: 0, right: 0}}>
                <Span textStyle={FontStyles.titleLightLarge}>{Localization.current.translation60}</Span>
            </Flex>
        </Flex>;
    }

    cancelAndQuit() {
        this.props.history.replace(Routes.myStories);
    }

    onTitleChange(e) {
        this.setState({
            title: e.target.value
        })
    }

    onAuthorChange(e) {
        this.setState({
            name: e.target.value
        })
    }

    async saveAndContinue() {
        await this.story.update({
            title: this.state.title,
            author: this.state.name || firebase.auth().currentUser.email.split('@')[0],
        });
        this.props.history.push(Routes.storyEditorWHash(this.storyId, this.pageN));
    }
}

export default StoryEditorTitle;
